import { motion } from "framer-motion";
import { MagnifyingGlass, Hand, Coffee } from "@phosphor-icons/react";

const steps = [
  {
    icon: MagnifyingGlass,
    title: "Browse local",
    body: "Open the app. See what's open.",
  },
  {
    icon: Hand,
    title: "Tap to order",
    body: "Tap, pay, done.",
  },
  {
    icon: Coffee,
    title: "Sit back",
    body: "It's on the way.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative bg-[#FAFAFA] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20 items-end">
          <div className="md:col-span-8">
            <p className="overline text-zinc-500 mb-5">How it works</p>
            <h2
              className="font-display font-extrabold tracking-tighter leading-[0.9] text-[64px] md:text-[104px] lg:text-[128px]"
              data-testid="how-it-works-headline"
            >
              <span className="gradient-text">just tap</span>{" "}
              <span className="italic font-semibold text-zinc-400">&amp;</span>{" "}
              <span className="gradient-text">wait.</span>
            </h2>
          </div>
          <div className="md:col-span-4">
            <p className="text-zinc-600 text-lg leading-relaxed max-w-md">
              Everything local, in one place.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`step-${i + 1}`}
              className="relative bg-white border border-zinc-100 rounded-3xl p-8 md:p-10 hover:-translate-y-1 hover:shadow-xl hover:shadow-zinc-900/5 transition-all duration-500"
            >
              <div className="absolute top-6 right-6 font-display font-black text-6xl text-zinc-100 leading-none select-none">
                0{i + 1}
              </div>
              <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl brand-gradient text-white mb-8">
                <s.icon size={26} weight="duotone" />
              </div>
              <h3 className="font-display font-extrabold text-2xl text-zinc-900 tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="text-zinc-600 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
